export const version = 'berater-v1.19.0-SNAPSHOT-99676322fe488a8376ab317d6fd8ec5c5ac0f2e9';